import { lazy, Suspense } from "react";
import CircularLoader from "../../customs/loader/main";

const Main = lazy(() => import("../../components/settings/licenseRenewalExamsSetup/main"));

const LicenseRenewalExamsSetup = () => {
  return (
        <Suspense fallback={<CircularLoader />}>
          <Main />
        </Suspense>
  );
};

export default LicenseRenewalExamsSetup;

